import { React, useState } from "react"
//import {fetchResourcesByFilter } from "../api/ResourceAPI.js";
import {
    fetchResourcesByFilter,
    fetchResourcesByTheme,
    fetchResourcesByQuery
} from "../api/ResourceAPI.js";
import APIFetcher from "../components/loading/APIFetcher.js";
import useHash from "../hooks/useHash.js";
import useQuery from "../hooks/useQuery.js";
import ResourceLayout from "../layouts/ResourceLayout.js";
import LeafletItem from "./LeafletItem.js"


const LeafletList = () => {
    // const { resourceType } = useParams();
    const resourceType = "leaflets"
    const { query, letter, theme } = useQuery();
    const hash = useHash(); // specialty, all, popular, favorite

    const [resources, setResources] = useState([]);
    const [usePagination, setPagination] = useState(true)

    const fetchItems = (page) => {
        const limit = 20;
        const offset = page * limit;

        const callback = (resources) => {
            if (page === 0)
                setResources(resources)
            else setResources(prevResources => prevResources.concat(resources))

            if (resources.length < limit)
                setPagination(false);
        }

        if (query)
            return fetchResourcesByQuery(resourceType, query, limit, offset).then(callback);
        if (hash === "specialty")
            return fetchResourcesByTheme(resourceType, theme, limit, offset).then(callback)
        return fetchResourcesByFilter(resourceType, hash, letter, limit, offset).then(callback)
    }
    

    return (
            <ResourceLayout resourceType={resourceType} >
            <APIFetcher fetchItems={fetchItems} hasItems={resources.length > 0} reloadOnChange={[resourceType,hash,query,letter,theme]} enablePagination={usePagination}>
                <LeafletItem resources={resources} resourceType={resourceType} />
            </APIFetcher>
            </ResourceLayout>
    );
}


export default LeafletList;
